import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationText',
  props: {
    errorMessage: {},
    noIndent: { type: Boolean },
    dataTestName: {}
  },
  setup(__props: any) {

const props = __props;



const dataTestErrorName = computed(() => (props.dataTestName ? `${props.dataTestName}-error` : ""));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _normalizeProps({
    class: ["pt-1 text-xs text-error", { 'pl-4': !_ctx.noIndent }],
    [dataTestErrorName.value || ""]: ''
  }), _toDisplayString(_ctx.errorMessage), 17))
}
}

})